"use client";
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import VenueCard from "../shared/card/venue/VenueCard";

const HotelChildCards = ({
	data,
	hasMore,
	isLoading,
	onLoadMore,
	showLess,
	breadcrumbPath,
	hotelId,
	venueCardTotalCount,
	showLessText = true,
	setIsMobile = () => {},
	getVenuesNumber,
}) => {
	const navigate = useNavigate();
	const [favorites, setFavorites] = useState({});
	const [isMobileView, setIsMobileView] = useState(false);
	const [currentSlide, setCurrentSlide] = useState(0);
	const [width, setWidth] = useState(0);
	const sliderRef = useRef(null);

	const toggleFavorite = (itemIndex, imageIndex) => {
		setFavorites((prevState) => ({
			...prevState,
			[itemIndex]: {
				...prevState[itemIndex],
				[imageIndex]: !prevState[itemIndex]?.[imageIndex],
			},
		}));
	};

	const handleViewPrev = (item) => {
		const cf = "hpv";
		const venueId = item?._id;

		const hotelNameSlug = item?.basicDetails?.hotelName
			?.toLowerCase()
			?.replace(/[^a-z0-9]+/g, "-")
			?.replace(/(^-|-$)/g, "");

		const slug = item?.basicDetails?.venueName
			?.toLowerCase()
			?.replace(/[^a-z0-9]+/g, "-")
			?.replace(/(^-|-$)/g, "");

		const updatedBreadcrumb = [...(breadcrumbPath || [])];

		// Fix second last breadcrumb if it exists and is the hotel
		if (
			updatedBreadcrumb.length &&
			updatedBreadcrumb[updatedBreadcrumb.length - 1]?.to === ""
		) {
			const hotelBreadcrumbPath = updatedBreadcrumb.slice(0);

			updatedBreadcrumb[updatedBreadcrumb.length - 1] = {
				...updatedBreadcrumb[updatedBreadcrumb.length - 1],
				to: {
					pathname: `/hotel-preview/${cf}/${hotelId}/${hotelNameSlug}`,
					search: `?breadcrumbPath=${encodeURIComponent(
						JSON.stringify(hotelBreadcrumbPath)
					)}`,
				},
			};
		}

		// Now add the current venue as last breadcrumb
		updatedBreadcrumb.push({
			name: item?.basicDetails?.venueName,
			to: "",
		});

		navigate(`/preview/${cf}/${venueId}/${hotelNameSlug}/${slug}`, {
			state: { breadcrumbPath: updatedBreadcrumb },
		});
	};

	useEffect(() => {
		const handleResize = () => {
			const isMobile = window.innerWidth < 1280; // Tailwind lg breakpoint
			setIsMobileView(isMobile);
			setIsMobile(isMobile);

			// if (isMobile) {
			// 	setTimeout(() => getVenuesNumber(), 1000);
			// }
		};

		handleResize();

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [isMobileView]);

	const CustomNextArrow = ({ onClick }) => (
		<div
			className="absolute right-2 h-fit bg-[#FFFFFF80] rounded-sm p-1 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				onClick(e);
			}}
		>
			<SlArrowRight className="text-[#000]" />
		</div>
	);

	const CustomPrevArrow = ({ onClick }) => (
		<div
			className="absolute left-2 h-fit bg-[#FFFFFF80] rounded-sm p-1 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				onClick(e);
			}}
		>
			<SlArrowLeft className="text-[#000] text-xl" />
		</div>
	);

	const imageSettings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
	};

	const mainCarouselSettings = {
		dots: true,
		speed: 500,
		dotClassName: "mt-2",
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		afterChange: (index) => setCurrentSlide(index),
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	const favoriteOverlayComp = (itemIndex, imageIndex) => {
		return (
			<div
				className="bg-white absolute top-3 right-5 p-1.5 rounded-full cursor-pointer"
				onClick={(e) => {
					e.stopPropagation();
					toggleFavorite(itemIndex, imageIndex);
				}}
			>
				{favorites[itemIndex]?.[imageIndex] ? (
					<IoMdHeart className="text-primary" />
				) : (
					<IoMdHeartEmpty className="text-primary" />
				)}
			</div>
		);
	};

	const getVenuActivity = (item) => {
		if (item?.additionalDetails?.venueSetting?.length === 1) {
			if (item?.additionalDetails?.venueSetting[0] === "Indoor + Outdoor")
				return "Indoor & Outdoor";
			else return item?.additionalDetails?.venueSetting[0];
		} else if (item?.additionalDetails?.venueSetting?.length > 1)
			return item?.additionalDetails?.venueSetting.join(" & ");
		else return "Indoor & Outdoor";
	};

	if (!data) {
		return null;
	}

	return (
		<>
			<div
				className="flex flex-col border-t border-b pb-8 pt-4"
				id="venue_child_cards"
			>
				<div>
					<p className="text-[#222222] text-[32px] font-bold  font-outfit mb-3">
						Other venues available at this space
					</p>
				</div>
				<div className="w-full">
					{isMobileView ? (
						<div className="relative px-4">
							{currentSlide > 0 && (
								<button
									onClick={() => sliderRef.current?.slickPrev()}
									className="absolute left-[-5px] top-1/2 -translate-y-1/2 z-10"
								>
									<FaCaretLeft className="size-5" />
								</button>
							)}
							{currentSlide < data.length - 1 && (
								<button
									onClick={() => sliderRef.current?.slickNext()}
									className="absolute right-[-5px] top-1/2 -translate-y-1/2 z-10"
								>
									<FaCaretRight className="size-5" />
								</button>
							)}
							<Slider {...mainCarouselSettings} ref={sliderRef}>
								{data.map((item, itemIndex) => (
									<div key={itemIndex} className="px-2 py-12">
										<VenueCard
											className="!min-h-[300px] !max-h-[300px]"
											key={itemIndex}
											onClick={(e) => {
												e.preventDefault();
												handleViewPrev(item);
											}}
										>
											<VenueCard.Slider
												images={item?.imagesAndVideos?.images}
												className="!h-[160px]"
											>
												{favoriteOverlayComp(itemIndex)}
											</VenueCard.Slider>
											<VenueCard.Details>
												<VenueCard.VenueName
													className={"!min-h-[52px] !max-h-[52px] !text-[16px]"}
												>
													{item?.basicDetails?.venueName},
													{item?.basicDetails?.hotelName}
												</VenueCard.VenueName>
												<VenueCard.Icons
													sittingCapacity={item?.capacity?.sitting}
													standingCapacity={item?.capacity?.standing}
												/>
												<VenueCard.Activity
													venueRepresent={item?.venueType?.venueRepresent}
													venueSetting={getVenuActivity(item)}
												/>
											</VenueCard.Details>
										</VenueCard>
									</div>
								))}
							</Slider>
						</div>
					) : (
						<>
							<div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
								{data.map((item, itemIndex) => (
									<VenueCard
										className="!min-h-[300px] !max-h-[300px]"
										key={itemIndex}
										onClick={(e) => {
											e.preventDefault();
											handleViewPrev(item);
										}}
									>
										<VenueCard.Slider
											images={item?.imagesAndVideos?.images}
											className="!h-[160px]"
										>
											{favoriteOverlayComp(itemIndex)}
										</VenueCard.Slider>
										<VenueCard.Details>
											<VenueCard.VenueName
												className={"!min-h-[52px] !max-h-[52px] !text-[16px]"}
											>
												{item?.basicDetails?.venueName},
												{item?.basicDetails?.hotelName}
											</VenueCard.VenueName>
											<VenueCard.Icons
												sittingCapacity={item?.capacity?.sitting}
												standingCapacity={item?.capacity?.standing}
											/>
											<VenueCard.Activity
												venueRepresent={item?.venueType?.venueRepresent}
												venueSetting={getVenuActivity(item)}
											/>
										</VenueCard.Details>
									</VenueCard>
								))}
							</div>
							{hasMore && (
								<div className=" mt-6">
									<button
										onClick={onLoadMore}
										disabled={isLoading}
										className="cursor-pointer text-[#fe4747] underline  font-medium transition-colors disabled:opacity-50"
									>
										{isLoading ? "Loading..." : "Show More"}
									</button>
								</div>
							)}
							{!hasMore && (
								<div className=" mt-6">
									<button
										onClick={showLess}
										disabled={isLoading}
										className="cursor-pointer text-[#fe4747] underline  font-medium transition-colors disabled:opacity-50"
									>
										{isLoading && "Loading..."}
										{showLessText && "Show less"}
									</button>
								</div>
							)}
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default HotelChildCards;
